"use client";

import { createContext, useEffect, useState } from "react";

export const GlobalContext = createContext(null);

export default function GlobalState({ children }) {
  const [userData, setUserData] = useState(null);
  const [connected, setConnected] = useState(null);
  const [panierStatus, setPanierStatus] = useState(1);
  const [demandeDevis, setDemandeDevis] = useState(false);
  const [panierData, setPanierData] = useState([]);
  const [locationShown, setLocationShown] = useState();

  useEffect(() => {
    const savedUserData = (JSON.parse(localStorage.getItem("user"))) ||null;
    const savedConnect = localStorage.getItem("connected");
    const savedPanierData = JSON.parse(localStorage.getItem("panier"));
    setUserData(savedUserData ? savedUserData : null);
    setConnected(savedConnect ? savedConnect : null);
    setPanierData(savedPanierData ? savedPanierData : null);
  }, []);
  return (
    <GlobalContext.Provider
      value={{
        demandeDevis,
        setDemandeDevis,
        panierData,
        setPanierData,
        panierStatus,
        setPanierStatus,
        connected,
        setConnected,
        userData,
        setUserData,
        locationShown,
        setLocationShown,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
}
